<template>
  <div class="app-container">
    <CrudTable entity="ProductType" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'description',
        { field: 'unitDescription', label: 'common.unit' },
        { field: 'stockUnitDescription', label: 'common.stockUnit' }
      ]
    };
  },
  methods: {
    generateSummary({ description }) {
      const summary = `${description}`;
      return summary;
    }
  }
};
</script>
